import { EnumRoleTypes } from "helpers/enum_helper"
import { useMemo } from "react"
import useUserDetail from "./useUserDetail"

export function useRole() {
  const { userprofile } = useUserDetail()

  return useMemo(() => {
    let roleTypeId = userprofile?.RoleTypeID
    const isAdmin = roleTypeId === parseInt(EnumRoleTypes.Administrator)
    const isParticipant = roleTypeId === parseInt(EnumRoleTypes.Participant)
    const isHost = roleTypeId === parseInt(EnumRoleTypes.Host)

    let roleLabel = null
    if (isAdmin) roleLabel = "User"
    else if (isParticipant) roleLabel = "User"
    else if (isHost) roleLabel = "User"

    return { isAdmin, isHost, isParticipant, roleLabel }
  }, [userprofile])
}
